module.exports = __webpack_public_path__ + "img/num_3.08bf3057.png";